<div id="company-code">
  <p class="TXT_TITLE">:: Setup Company Code ::</p>
  <div class="cc-actions">
    <button nz-button nzType="default" (click)="showAddForm()">
      <img
        class="iconImage"
        src="../../../../assets/icons/new.gif"
        alt="New Item Icon"
      />
      <span class="textColor ml-6">Add New Company Code</span>
    </button>

    <button
      nz-button
      nzType="default"
      (click)="deleteSelected()"
      [disabled]="selectedIds.size === 0"
    >
      <img
        class="iconImage"
        src="../../../../assets/icons/del.gif"
        alt="Delete Icon"
      />
      <span class="textColor ml-6">Delete Selected Company Code</span>
    </button>
  </div>

  <nz-table
    class="StyleTable w-50"
    nzBordered
    #companyCodesData
    [nzData]="companyCodes"
    [nzNoResult]="customNoDataMessage"
    [nzShowPagination]="false"
    [nzPageSize]="companyCodes.length"
  >
    <thead>
      <tr>
        <th></th>
        <th>Company Code</th>
        <th>Company Branch/Plant</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let code of companyCodesData.data; let i = index">
        <td class="action-col">
          <input
            type="checkbox"
            (change)="toggleSelection(code.ccnId)"
            [checked]="selectedIds.has(code.ccnId)"
            *ngIf="!code.isCCNAttached"
          />
        </td>
        <td>{{ code.ccnCode }}</td>
        <td>{{ code.ccnBranchPlant }}</td>
      </tr>
    </tbody>
  </nz-table>

  <div class="popupStyle" *ngIf="showAddFormPopup">
    <div class="popup" (click)="closePopup()">
      <div class="popup-content" (click)="$event.stopPropagation()">
        <div class="popup-header">
          <p class="TXT_TITLE">: : ADD Company Code : :</p>
          <span class="close" (click)="closePopup()">&times;</span>
        </div>
        <div class="popup-body">
          <div>
            <form
              [formGroup]="addForm"
              (ngSubmit)="addCompanyCode()"
              class="company-form"
            >
              <label
                >*Company Code:
                <input
                  nz-input
                  formControlName="ccnCode"
                  placeholder="Enter Company Code"
                />
              </label>
              <div class="error" *ngIf="addForm.get('ccnCode')?.touched">
                <div *ngIf="addForm.get('ccnCode')?.errors?.['pattern']">
                  Company Code is only Number
                </div>
                <div *ngIf="addForm.get('ccnCode')?.errors?.['required']">
                  Company Code is required.
                </div>
              </div>

              <label
                >*Branch/Plant:
                <input
                  nz-input
                  formControlName="ccnBranchPlant"
                  placeholder="Enter Branch/Plant"
                  type="text"
                />
              </label>
              <div
                class="error"
                *ngIf="
                  addForm.get('ccnBranchPlant')?.invalid &&
                  addForm.get('ccnBranchPlant')?.touched
                "
              >
                Branch/Plant is required.
              </div>

              <div style="margin-top: 10px">
                <button
                  type="submit"
                  nz-button
                  nzType="primary"
                  [disabled]="addForm.invalid"
                >
                  SAVE
                </button>
                <button
                  type="button"
                  nz-button
                  nzType="default"
                  (click)="closePopup()"
                  style="margin-left: 15px"
                >
                  Back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
